const PlusIcon = () => (
  <svg width="16px" viewBox="0 0 13 24" version="1.1">
    <path
      fill="currentColor"
      d="M5.5 16.802L7 16.802L7 12.682L11.14 12.682L11.14 11.242L7 11.242L7 7.12195L5.5 7.12195L5.5 11.242L1.36 11.242L1.36 12.682L5.5 12.682L5.5 16.802Z"
    />
  </svg>
);
export default PlusIcon;
